
import EducationCard from "./EducationCard.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import { AmSpacing } from "@afe/amui/src/components/Spacing";
import { AmTypography } from "@afe/amui/src/components/Typography";
import { AmIcon } from "@afe/amui/src/components/Icon";
import { AmButton } from "@afe/amui/src/components/Button";
import {
  AmCard,
  AmCardHeader,
  AmCardBody,
  AmCardFooter
} from "@afe/amui/src/components/Card";

@Component({
  components: {
    AmCard,
    AmCardHeader,
    AmCardBody,
    AmCardFooter,
    AmTypography,
    AmSpacing,
    AmIcon,
    AmButton,
    EducationCard
  }
})
export default class extends Vue {
  @Prop(String) readonly cards_data!: string;
  @Prop(String) readonly card_button!: string;
  @Prop(String) readonly load_more_button?: string;
  @Prop(Number) readonly cards_count!: number;
  @Prop(Number) readonly offset?: number;
  parsed_cards = JSON.parse(this.cards_data);
  cards = [] as object[];
  limit = 6;
  count = 0;
  all_loaded = false;

  created() {
    if (this.parsed_cards) {
      if (!this.offset) {
        const offset = this.count + this.limit;
        if (offset < this.cards_count) {
          this.cards = this.parsed_cards.slice(this.count, this.limit);
          this.count += this.limit;
        } else {
          this.cards = this.parsed_cards;
          this.all_loaded = true;
        }
      } else {
        this.count += this.offset;

        if (this.parsed_cards.length <= this.count) {
          this.all_loaded = true;
        }
      }
    }
  }

  loadCards() {
    const offset = this.count + this.limit;

    if (offset < this.cards_count) {
      this.cards = [
        ...this.cards,
        ...this.parsed_cards.slice(this.count, offset)
      ];

      this.count += this.limit;
    } else {
      const left_cards = this.cards_count - this.cards.length;

      this.cards = [
        ...this.cards,
        ...this.parsed_cards.slice(this.count, this.count + left_cards)
      ];

      this.all_loaded = true;
    }
  }
}
